import React from 'react';

const P = (props) => {
    return (<p className={props.clase}>{props.valor}</p>);
}

export default P;